'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocationUrl = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MUTED = 'rgba(0,0,0,.5)';
var LINK = '#1e5b99';

// Block so it always sits on its own line, whatever the caption above renders as.
var linkStyle = {
  display: 'block',
  maxWidth: '95%',
  marginTop: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: '0.85em',
  fontWeight: 400,
  color: MUTED
};
var iconStyle = { width: 'auto', margin: '0 4px 0 0' };

var getLocationUrl = exports.getLocationUrl = function getLocationUrl(location) {
  return _lodash2.default.get(location, 'id') ? 'https://www.instagram.com/explore/locations/' + location.id + '/' : '';
};

// Tagged Instagram place under a post or story caption; renders nothing without one.
var LocationLink = function LocationLink(_ref) {
  var location = _ref.location;

  var url = getLocationUrl(location);
  if (!url) return null;
  var name = location.name || 'View location';
  return _react2.default.createElement(
    'a',
    {
      href: url,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: name + ' \xB7 Open on Instagram',
      style: linkStyle,
      className: 'report-location',
      onMouseEnter: function onMouseEnter(e) {
        e.currentTarget.style.color = LINK;
      },
      onMouseLeave: function onMouseLeave(e) {
        e.currentTarget.style.color = MUTED;
      }
    },
    _react2.default.createElement(_semanticUiReact.Icon, { name: 'marker', style: iconStyle }),
    name
  );
};

exports.default = LocationLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/basic-report-row/components/location-link.js
 ** module id = 606
 ** module chunks = 0
 **/